













import { Component, mixins } from '@niknevis/vue-modules'
import { FilterComponentsMixin } from '@/modules/common/filter/mixins/filterComponentsMixin'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'

@Component({
  components: {
    Toggle
  }
})
export default class ToggleFilter extends mixins(FilterComponentsMixin) {
  protected default = false

  public get model() {
    if (!this.filter.key) return false
    return Boolean(this.service.get(this.filter.key)) || this.default
  }

  public set model(value: any) {
    if (this.filter.key) {
      this.service.add(this.filter.key, value ? 1 as any : null)
    }
  }
}
